var _g, _mask, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJavaTracerColorIcon = function SvgJavaTracerColorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 34,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#java-tracer-color-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4E7896",
    d: "M10.133 21.57s-1.073.652.745.839c2.189.279 3.354.233 5.776-.233a8.7 8.7 0 0 0 1.538.746c-5.45 2.33-12.345-.14-8.06-1.352m-.698-3.028s-1.164.885.653 1.073c2.375.232 4.239.279 7.454-.373.313.317.696.557 1.118.699-6.569 1.956-13.93.185-9.225-1.399m12.858 5.31s.792.652-.885 1.165c-3.121.933-13.09 1.212-15.886 0-.978-.419.885-1.025 1.483-1.118.606-.14.933-.14.933-.14-1.073-.745-7.128 1.538-3.075 2.189 11.134 1.817 20.312-.792 17.423-2.096zm-11.656-8.478s-5.078 1.212-1.817 1.63c1.397.187 4.146.14 6.708-.046 2.096-.187 4.194-.558 4.194-.558s-.746.326-1.258.652c-5.17 1.352-15.094.746-12.252-.652 2.422-1.165 4.426-1.024 4.426-1.024zm9.085 5.078c5.217-2.703 2.795-5.31 1.117-4.985-.418.093-.605.187-.605.187s.14-.28.465-.373c3.308-1.165 5.917 3.494-1.072 5.31 0 0 .046-.046.093-.14zm-8.57 7.36c5.03.326 12.717-.187 12.903-2.563 0 0-.372.933-4.146 1.63-4.286.792-9.596.697-12.718.187 0 0 .652.559 3.96.746"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F58219",
    d: "M16.562 0s2.889 2.936-2.748 7.361c-4.519 3.587-1.024 5.637 0 7.967-2.656-2.376-4.565-4.473-3.26-6.429 1.909-2.89 7.173-4.278 6.008-8.898M15.08 13.372c1.351 1.537-.372 2.935-.372 2.935s3.447-1.77 1.863-3.96c-1.444-2.096-2.563-3.122 3.493-6.615 0 0-9.55 2.376-4.984 7.64"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "java-tracer-color-icon_svg__b",
    width: 15,
    height: 19,
    x: 17.375,
    y: 14.825,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.375 14.825h15v19h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 26.21c.999 0 1.808-.805 1.808-1.797 0-.993-.81-1.797-1.808-1.797-.999 0-1.808.804-1.808 1.797s.81 1.796 1.808 1.796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.225 20.22 24.8 17.826l-5.425 2.396v3.593c0 3.323 2.315 6.431 5.425 7.186 1.386-.335 2.61-1.138 3.544-2.222l-1.88-1.868c-1.17.772-2.761.64-3.792-.384a2.983 2.983 0 0 1 0-4.233 3.03 3.03 0 0 1 4.262 0 2.984 2.984 0 0 1 .386 3.766l1.748 1.737a7.6 7.6 0 0 0 1.157-3.982z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1254A1",
    d: "M24.8 26.21c.999 0 1.808-.805 1.808-1.797 0-.993-.81-1.797-1.808-1.797-.999 0-1.808.804-1.808 1.797s.81 1.796 1.808 1.796"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1254A1",
    d: "M30.225 20.22 24.8 17.826l-5.425 2.396v3.593c0 3.323 2.315 6.431 5.425 7.186 1.386-.335 2.61-1.138 3.544-2.222l-1.88-1.868c-1.17.772-2.761.64-3.792-.384a2.983 2.983 0 0 1 0-4.233 3.03 3.03 0 0 1 4.262 0 2.984 2.984 0 0 1 .386 3.766l1.748 1.737a7.6 7.6 0 0 0 1.157-3.982z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 4,
    d: "M24.8 26.21c.999 0 1.808-.805 1.808-1.797 0-.993-.81-1.797-1.808-1.797-.999 0-1.808.804-1.808 1.797s.81 1.796 1.808 1.796Z",
    mask: "url(#java-tracer-color-icon_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 4,
    d: "M30.225 20.22 24.8 17.826l-5.425 2.396v3.593c0 3.323 2.315 6.431 5.425 7.186 1.386-.335 2.61-1.138 3.544-2.222l-1.88-1.868c-1.17.772-2.761.64-3.792-.384a2.983 2.983 0 0 1 0-4.233 3.03 3.03 0 0 1 4.262 0 2.984 2.984 0 0 1 .386 3.766l1.748 1.737a7.6 7.6 0 0 0 1.157-3.982z",
    mask: "url(#java-tracer-color-icon_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "java-tracer-color-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27.9v27.9H0z"
  })))));
};
export default SvgJavaTracerColorIcon;